














































































import { Component, Vue, Prop } from 'vue-property-decorator'
import FilterChart from './Components/FilterChart.vue'
import FilterTablePowerUser from './Components/FilterTablePowerUser.vue'
import TableMenu from './Components/TableMenu.vue'
import BarChart from './Components/BarChart/BarChart.vue'
import TableDealer from './Components/TableDealer.vue'
import TopMenu from './Components/TopMenu.vue'
import TableMaterial from './Components/TableMaterial.vue'
import { AuthModule } from '@/app/store/modules/auth'
import LineChart, { ILineChartData } from './Components/LineChart/LineChart.vue'
import { TrainingMaterialReportModule } from '@/app/store/modules/trainingMaterialReport'
import Pagination from '@/app/ui/components/Pagination/index'

@Component({
  name: 'DashboardAdmin',
  components: {
    'top-menu': TopMenu,
    'bar-chart': BarChart,
    'line-chart': LineChart,
    'table-menu': TableMenu,
    'table-dealer': TableDealer,
    'filter-chart': FilterChart,
    'filter-table-power-user': FilterTablePowerUser,
    'table-material': TableMaterial,
    pagination: Pagination,
  },
})
export default class extends Vue {
  public created() {
    // TrainingMaterialReportModule.paginationParam.filter.salescode = ''
    TrainingMaterialReportModule.paginationParam.filter.team = ''
    TrainingMaterialReportModule.paginationParam.filter.position = ''
    TrainingMaterialReportModule.paginationParam.filter.typeSales = ''
    TrainingMaterialReportModule.paginationParam.filter.category = ''
    TrainingMaterialReportModule.paginationParam.filter.start = ''
    TrainingMaterialReportModule.paginationParam.filter.end = ''
    // TrainingMaterialReportModule.paginationParamsExport.filter.salescode = ''
    TrainingMaterialReportModule.paginationParamsExport.filter.team = ''
    TrainingMaterialReportModule.paginationParamsExport.filter.position = ''
    TrainingMaterialReportModule.paginationParamsExport.filter.typeSales = ''
    TrainingMaterialReportModule.paginationParamsExport.filter.category = ''
    TrainingMaterialReportModule.paginationParamsExport.filter.start = ''
    TrainingMaterialReportModule.paginationParamsExport.filter.end = ''
    this.getTrainingReportData()
    this.getExportData()
  }
  public get needSalesCode() {
    const powerUser = AuthModule.salesCode.role
    if (powerUser !== 'Super Admin') {
      return true
    }
    return false
  }
  public get getTrainingReportData(): any {
    return TrainingMaterialReportModule.getTrainingMaterialData
  }

  public get TopMenuData(): any {
    return TrainingMaterialReportModule.TrainingMaterialData.topMenu
  }
  public get ChartData(): any {
    return TrainingMaterialReportModule.TrainingMaterialData.chart
  }
  public get dataAccessRateCharts(): any {
    return TrainingMaterialReportModule.TrainingMaterialData.accessRateCharts
  }
  public get TopVisit(): any {
    return TrainingMaterialReportModule.TrainingMaterialData.topVisit
  }
  public get TopVisitByType(): any {
    return TrainingMaterialReportModule.TrainingMaterialData.topVisitType
  }
  public get MaterialDetailVist(): any {
    return TrainingMaterialReportModule.TrainingMaterialData.materialVisitDetail
  }
  public get MaterialVisitPagination(): any {
    return TrainingMaterialReportModule.TrainingMaterialData
      .materialVisitPagination
  }

  public get isLoading(): boolean {
    return TrainingMaterialReportModule.isLoading
  }
  public get getExportData(): any {
    return TrainingMaterialReportModule.getExportData
  }
  public get isLoadingExport() {
    return TrainingMaterialReportModule.isLoadingExport
  }
  public get linkExport(): any {
    return TrainingMaterialReportModule.exportData.data
  }

  private onPageNumChanged(limit: any) {
    TrainingMaterialReportModule.paginationParam.paging.limit = limit
    this.getTrainingReportData()
  }

  private funcFirstPage() {
    TrainingMaterialReportModule.paginationParam.paging.page = 1
    this.getTrainingReportData()
  }

  private funcPrevPage() {
    TrainingMaterialReportModule.paginationParam.paging.page =
      TrainingMaterialReportModule.paginationParam.paging.page - 1
    this.getTrainingReportData()
  }
  private funcNextPage() {
    TrainingMaterialReportModule.paginationParam.paging.page =
      TrainingMaterialReportModule.paginationParam.paging.page + 1
    this.getTrainingReportData()
  }

  private funcLastPage() {
    TrainingMaterialReportModule.paginationParam.paging.page =
      (this.getTrainingReportData.MaterialDetailVisitPagination &&
        this.getTrainingReportData.MaterialDetailVisitPagination.pageCount) ||
      0
    this.getTrainingReportData()
  }

  // Property Top Menu
  private funcFilter(data) {
    // TrainingMaterialReportModule.paginationParam.filter.salescode =
    TrainingMaterialReportModule.paginationParam.filter.team = data.team
    TrainingMaterialReportModule.paginationParam.filter.position =
      data.byPosition3
    TrainingMaterialReportModule.paginationParam.filter.typeSales =
      data.typeSales
    TrainingMaterialReportModule.paginationParam.filter.category = data.category.split(
      '/'
    )[1]
    TrainingMaterialReportModule.paginationParam.filter.start =
      data.filterDate[0]
    TrainingMaterialReportModule.paginationParam.filter.end = data.filterDate[1]
    TrainingMaterialReportModule.paginationParamsExport.filter.start =
      data.filterDate[0]
    TrainingMaterialReportModule.paginationParamsExport.filter.end =
      data.filterDate[1]
    this.getTrainingReportData()
    this.getExportData()
  }

  private funcClearFilter() {
    this.clearFilter()
    // TrainingMaterialReportModule.paginationParam.filter.salescode = ''
    TrainingMaterialReportModule.paginationParam.filter.team = ''
    TrainingMaterialReportModule.paginationParam.filter.position = ''
    TrainingMaterialReportModule.paginationParam.filter.typeSales = ''
    TrainingMaterialReportModule.paginationParam.filter.category = ''
    TrainingMaterialReportModule.paginationParam.filter.start = ''
    TrainingMaterialReportModule.paginationParam.filter.end = ''
    // TrainingMaterialReportModule.paginationParamsExport.filter.salescode = ''
    TrainingMaterialReportModule.paginationParamsExport.filter.position = ''
    TrainingMaterialReportModule.paginationParamsExport.filter.typeSales = ''
    TrainingMaterialReportModule.paginationParamsExport.filter.team = ''
    TrainingMaterialReportModule.paginationParamsExport.filter.category = ''
    TrainingMaterialReportModule.paginationParamsExport.filter.start = ''
    TrainingMaterialReportModule.paginationParamsExport.filter.end = ''
    this.getTrainingReportData()
    this.getExportData()
  }

  public get hasFilter(): boolean {
    if (
      // TrainingMaterialReportModule.paginationParam.filter.salescode !== '' ||
      TrainingMaterialReportModule.paginationParam.filter.team !== '' ||
      TrainingMaterialReportModule.paginationParam.filter.position !== '' ||
      TrainingMaterialReportModule.paginationParam.filter.typeSales !== '' ||
      TrainingMaterialReportModule.paginationParam.filter.category !== '' ||
      TrainingMaterialReportModule.paginationParam.filter.start !== '' ||
      TrainingMaterialReportModule.paginationParam.filter.end !== ''
    ) {
      return true
    } else {
      return false
    }
  }
  private onClearFilter: boolean = false
  private clearFilter() {
    if (this.onClearFilter === false) {
      this.onClearFilter = true
    } else {
      this.onClearFilter = false
    }
  }

  private nameCharts = 'User Access Graphic'
}
